import React from 'react'
import TableRow from './TableRow'

const PriorityStoreTable = ({ loading, listStore, error, reload, listProductType, setModal, getDetailStore }) => {

    const _renderTableContent = () => {
        if (loading) {
            return <tr>
                <td colSpan={4}>Loading ...</td>
            </tr>
        }

        if (listStore.length === 0 && !error) {
            return <tr>
                <td colSpan={4}>No data</td>
            </tr>
        }

        if (!!error) {
            return <tr>
                <td colSpan={4} className='text-danger'>{error}</td>
            </tr>
        }

        return listStore.length > 0 && listStore.map((item) => {
            return <TableRow
                key={item._id}
                item={item}
                reload={reload}
                listProductType={listProductType}
                setModal={setModal}
                getDetailStore={getDetailStore}
                listStore={listStore}
            />
        })
    }

    return (
        <div className="PriorityStoreTable SkuTable">
            <table className="table table-striped">
                <thead className="TableHead">
                    <tr>
                        <th className="StoreName">Store</th>
                        <th className="Sku">SKU</th>
                        <th className="Updated">Updated at</th>
                        <th className="Action">Action</th>
                    </tr>
                </thead>
                <tbody className="TableBody">
                    {_renderTableContent()}
                </tbody>
            </table>
        </div>
    )
}

export default PriorityStoreTable